// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2DBFk","header":"MergedInvoice_header__1qr9E"};